import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MenuBar } from './menu-bar.model';
import { map } from 'rxjs/operators'
import { Observable } from 'rxjs';

export interface Conversions {
    Array<IUnitGroup>();
}

@Injectable()
export class MenuBarService {

    //conversionData: Array<IUnitGroup>;
    manifestUrl: string = './manifest.json';

    constructor(private http: HttpClient) { }

    getManifest(): Observable<MenuBar> {
        //return this.http.get(this.manifestUrl);
        return this.http.get(this.manifestUrl).pipe(
            map((e: MenuBar) => e)
        );
    }

}
